
































import BookingAllowanceUser from "@/components/customers/booking-allowance-user.vue";
import Card from "@/components/layout/card.vue";
import UserSelector from "@/components/pickers/user-selector.vue";
import { userService } from "@/services/user";
import { User } from "@/swagger/models";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "BookingAllowance",
    components: { BookingAllowanceUser, UserSelector, Card },
})
export default class BookingAllowance extends Vue {
    @Prop({ required: true })
    customerId: number;

    users: User[] = [];

    async created() {
        await this.refreshUsers();
    }

    async setAllowance(user: User, value: number | null) {
        // @ts-ignore (maxReservations is object in swagger model)
        user.maxReservations = value;
        await userService.patch(user.id, {
            customerId: user.customerId,
            maxReservations: value,
        });
    }

    async removeAllowance(user: User) {
        await this.setAllowance(user, null);
        this.users = this.users.filter((u) => u !== user);
    }

    @Watch("customerId")
    async refreshUsers() {
        this.users = await userService.search({
            customer: this.customerId,
            withMaxReservations: true,
        });
    }

    async addUser(user: User) {
        // @ts-ignore
        await this.setAllowance(user, this.$context.customer.maxReservations || 1);
        this.users.unshift(user);
    }

    get pickerFilter() {
        return (user: User) => !this.users.some((u) => u.id === user.id);
    }
}
